import { Avatar, Chip, Stack, Typography, Box } from "@mui/material";
import { useFormatter } from "../../../utils/useFormatter";

interface IProps {
  namePractitioner: string;
  selectedPractitioner: boolean;
  healthcare: any;
  serviceCost?: number;
  onClick: VoidFunction;
}

export function CardProfessional({
  namePractitioner,
  selectedPractitioner,
  healthcare,
  serviceCost,
  onClick,
}: IProps) {
  const nameCustom = namePractitioner;

  const hasCost = Number(serviceCost) > 0;

  return (
    <Stack
      width="100%"
      minWidth="20%"
      p={1.5}
      spacing={1}
      border={selectedPractitioner ? "2px solid" : "1px solid"}
      borderColor={selectedPractitioner ? "primary.main" : "neutral400.main"}
      borderRadius="8px"
      onClick={onClick}
      sx={{
        backgroundColor: selectedPractitioner ? "action.selected" : "neutral0.main",
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          borderColor: "primary.main",
          backgroundColor: selectedPractitioner ? "action.selected" : "action.hover",
        },
      }}
    >
      <Box sx={{ display: "flex", gap: 1.5, alignItems: "flex-start", width: "100%" }}>
        <Avatar
          sx={(theme) => ({
            width: 32,
            height: 32,
            backgroundColor: theme.palette.action.hover,
            color: selectedPractitioner ? theme.palette.primary.main : theme.palette.text.primary,
            fontSize: "14px",
            fontWeight: 700,
            mt: 0.25
          })}
        >
          {nameCustom.charAt(0)}
        </Avatar>

        <Stack spacing={0.5} sx={{ minWidth: 0, flex: 1 }}>
          <Typography 
            variant="body2" 
            noWrap
            sx={{ 
              fontWeight: selectedPractitioner ? 700 : 500,
              fontSize: "14px",
              color: selectedPractitioner ? "primary.main" : "text.primary",
              lineHeight: 1.2
            }}
          >
            Dr(a). {nameCustom}
          </Typography>

          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, alignItems: "center" }}>
            {healthcare && (
              <Chip
                label={healthcare}
                size="small"
                variant="outlined"
                sx={{
                  height: "20px",
                  fontSize: "0.65rem",
                  fontWeight: 600,
                  borderColor: "divider",
                  backgroundColor: "background.paper",
                  "& .MuiChip-label": { px: 0.5 }
                }}
              />
            )}

            {hasCost && (
              <Chip
                label={useFormatter?.formatCurrency(Number(serviceCost) * 100)}
                size="small"
                color={selectedPractitioner ? "primary" : "default"}
                variant={selectedPractitioner ? "filled" : "outlined"}
                sx={{
                  height: "20px",
                  fontWeight: 700,
                  fontSize: "0.65rem",
                  borderColor: "divider",
                  "& .MuiChip-label": { px: 0.5 }
                }}
              />
            )}
          </Box>
        </Stack>
      </Box>
    </Stack>
  );
}
